import React, {Component} from "react";
import {NavLink} from 'react-router-dom'
import {getDateFormat} from "../../../../../utils/functions";
import * as func from "../../../../../utils/functions";
import * as hooks from "../../../../../utils/hooks";
import {BASE_PATH} from "../../../../../wpconfig";
import Loading from "../../../../etc/loading";
import ResourceItem from "../../../../resource/front/list/Resourceitem";

class DDeptArticle extends Component {
	constructor(props) {
		super(props);

		// console.log(this.props.record.category_id)
		this.state = {
			isInit: false,
			param: {
				'current_page': 1,
				'record_per_page': 5,
				'ks': '',
				'sub_ks': '',
				'jcr_category': [],
				'kci_category': [],
				'scopus_category': [],
				'publisher': [],
				'registered_db_name': [],
				'registered_db_year': [],
				'journal_ranking': [],
				'dept_id': [this.props.record.category_id],
				'order_by': 'ranking',
				'order': 'desc',
				'journal_status': [],
				'date_type': 'input_date',
				'in_date_start': '',
				'in_date_end': '',
			},
			records: []
		}
	}

	componentDidMount() {
		this.getList();
	}

	getList() {
		func.getData("resources", this.state.param).then((response) => {
			this.setState({
				isInit: true,
			})
			this.setState({records: response.records})
		});
	}

	render() {
		const records = this.state.records;

		return (
			<>
				{this.state.isInit ?
					<div className="mt-65">
						<div className="d-flex justify-content-between align-items-center mb-px-26">
							<div className="d-flex align-items-center">
								<h3 className="con-title">학과 논문</h3>
							</div>
						</div>
						<div>
							<div className="line-list-group">
								{records.map((record, index) => {
									return (
										<ResourceItem key={index} record={record}/>
									)
								})}
							</div>
						</div>
						<div className="mt-4">
							<div className="text-center">
								<NavLink to={BASE_PATH + "resources/?current_page=1&record_per_page=20&ks=&sub_ks=&dept[]=" +
								this.props.record.category_name +
								"&order_by=date&order=desc&date_type=input_date&in_date_start=&in_date_end="}
								         className="btn btn-outline-gray btn-lg">
									<span className="icon icon-size-24 icon-plus-black align-top mr-2"/>
									<strong>
										논문 전체보기
									</strong>
								</NavLink>
							</div>
						</div>
					</div> : <div className="mt-65"><Loading/></div>
				}
			</>
		)
	}
};

export default DDeptArticle;
